import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../../../components/Form/Input";
import Submit from "../../../../../../components/Form/Submit";
import Grid from "../../../../../../components/Grid";
import Modal from "../../../../../../components/Modal";
import { Center } from "../../../../../../components/StyledComponents";
import {
  schema,
  initialValues,
} from "../../../../../../constants/form/recruiting/ait/create-company";
import { connect, useDispatch } from "react-redux";
import Button from "../../../../../../components/Button";
import { hideModal, showModal } from "../../../../../../store/actions/modal";
import actionsData from "../../../../../../store/actions/recruiting/index";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { UserDto } from "../../../../../../types/user.dto";
interface ComponentProps {
  companiesStates: {
    loading: boolean;
    error: boolean | string;
    success: boolean;
  };
  user: UserDto;
}

const Index = ({ companiesStates, user }: ComponentProps) => {
  const dispatch = useDispatch();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const params = useParams();
  const onSubmit = (values, actions) => {
    const data = !params.id
      ? { external: true, user: user._id }
      : { external: true, team: params.id };
    dispatch(actionsData.company.create({ ...values, ...data }));
    setFormActions(actions);
  };

  useEffect(() => {
    if (companiesStates.success) {
      toast.success("👌🏼 Empresa creada exitosamente");
      dispatch(hideModal());
      setTimeout(() => {
        dispatch(actionsData.company.resetCreate());
        formActions?.resetForm();
      }, 1000);
    }

    if (companiesStates.error) {
      toast.error(`😱 ${companiesStates.error}`);

      setTimeout(() => {
        dispatch(actionsData.company.resetCreate());
      }, 1000);
    }
  }, [companiesStates]);

  return (
    <>
      <Button
        onClick={() => dispatch(showModal("create-company-modal"))}
        options={{
          type: "outline",
          size: "md",
          skin: "gray",
        }}
      >
        Agregar Empresas
      </Button>
      <Modal name="create-company-modal" title="Crear Empresa" width={"580px"}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, actions) => onSubmit(values, actions)}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={schema}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                id="create-company-form"
              >
                <Grid.Row>
                  <Grid.Col>
                    <Input
                      name="name"
                      modal
                      error={errors["name"]}
                      touched={touched["name"]}
                      value={values["name"]}
                      type="text"
                      placeholder=""
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        label: "Empresa",
                        marginBottom: 24,
                      }}
                    />
                  </Grid.Col>
                </Grid.Row>
                <Center>
                  <Submit
                    isSubmmiting={companiesStates.loading}
                    form="create-company-form"
                    color="Primary"
                    options={{
                      type: "filled",
                      skin: "primary",
                      size: "lg",
                      marginBottom: "0px",
                    }}
                  >
                    Confirmar
                  </Submit>
                </Center>
              </form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

const states = ({ recruitingStore, userStore }) => {
  const { states: companiesStates } = recruitingStore.company.create;
  const { data: user } = userStore;
  return {
    companiesStates,
    user,
  };
};

export default connect(states)(Index);
